import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Translations_en } from "./translations/en/translations";
import { Translations_ro } from "./translations/ro/translations";
import { Translations_hu } from "./translations/hu/translations";
import LanguageDetector from "i18next-browser-languagedetector";
import { Translations_bg } from "./translations/bg/translations";
const resources = {
    en: {
        translation: Translations_en
    },
    ro: {
        translation: Translations_ro
    },
    hu: {
        translation: Translations_hu
    },
    bg: {
        translation: Translations_bg
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        fallbackLng: "en",
        detection: {
            lookupQuerystring: "langCode"
        },
        resources: resources,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;